module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "country-input",
    on: {
      "click": _vm.showPrefixMenu
    }
  }, [_c('div', {
    ref: "country",
    staticClass: "mdl-textfield mdl-textfield--floating-label is-upgraded",
    class: {
      'is-invalid': _vm.invalid || (_vm.required && _vm.empty),
        'is-dirty': !_vm.empty
    }
  }, [_c('span', {
    staticClass: "value mdl-textfield__input"
  }, [(!_vm.empty) ? _c('span', {
    staticClass: "countryFlag flag-icon",
    class: 'flag-icon-' + (_vm.liveValue.toLowerCase())
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.name) + "  \n    ")]), _vm._v(" "), _c('span', {
    staticClass: "mdl-textfield__label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "more"
  }, [_c('span', [_vm._v("▾")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2636998a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/CountryInput.vue
// module id = 437
// module chunks = 0